import { trackApiCall } from "./metrics";

const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

async function request<T>(method: string, path: string, data?: unknown): Promise<T> {
  const t0 = performance.now();
  let ok = true;
  try {
    const res = await fetch(`${BASE}/api${path}`, {
      method,
      headers: data ? { "Content-Type": "application/json" } : {},
      body: data ? JSON.stringify(data) : undefined,
      credentials: "include",
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      ok = false;
      const err = new Error(json?.error || `Request failed: ${res.status}`) as Error & { response: { data: typeof json } };
      err.response = { data: json };
      throw err;
    }
    return json as T;
  } finally {
    trackApiCall(method, path, Math.round(performance.now() - t0), ok);
  }
}

export function apiPost<T = unknown>(path: string, data?: unknown): Promise<T> {
  return request<T>("POST", path, data);
}

export function apiGet<T = unknown>(path: string): Promise<T> {
  return request<T>("GET", path);
}

export function apiPut<T = unknown>(path: string, data?: unknown): Promise<T> {
  return request<T>("PUT", path, data);
}

export function apiDelete<T = unknown>(path: string): Promise<T> {
  return request<T>("DELETE", path);
}

export function apiPatch<T = unknown>(path: string, data?: unknown): Promise<T> {
  return request<T>("PATCH", path, data);
}
